import { notifyError } from "src/assets/toastService";

export const errorHandling = (error: any) => {
  console.log(error);
  notifyError(error?.response?.data?.message || error?.response?.data?.error || "An unexpected error occurred. Please try again.");
};
